'use client';

import React, { useEffect, useState } from 'react';
import NextImage from 'next/image';
import classnames from 'classnames';
import { useStore } from '@frodo/lib/hooks';
import { getPublicImagePath } from '@frodo/lib/utils/common/urlUtils';
import cls from './Image.module.scss';

export type ImageProps = {
  alt: React.ComponentProps<typeof NextImage>['alt'];
  width?: number;
  height?: number;
  ignoreAspectRatio?: boolean;
  src: React.ComponentProps<typeof NextImage>['src'];
  sizes?: React.ComponentProps<typeof NextImage>['sizes'];
  className?: string;
  nextProps?: Partial<
    Omit<
      React.ComponentProps<typeof NextImage>,
      'src' | 'alt' | 'sizes' | 'width' | 'height'
    >
  >;
  qa?: string;
};

export const Image = ({
  src,
  className,
  alt,
  nextProps,
  sizes,
  width,
  height,
  ignoreAspectRatio = false,
  qa,
}: ImageProps) => {
  const store = useStore();
  const [hasError, setHasError] = useState<boolean>(false);
  const defaultImage = getPublicImagePath(store.fallbackImage);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  return (
    <NextImage
      data-qa={qa}
      className={classnames(className, { [cls.image]: !ignoreAspectRatio })}
      onError={() => {
        setHasError(true);
      }}
      src={hasError ? defaultImage : src || defaultImage}
      alt={alt}
      sizes={sizes}
      width={width}
      height={height}
      unoptimized={true}
      style={ignoreAspectRatio ? {} : { aspectRatio: `${width}/${height}` }}
      {...nextProps}
    />
  );
};
